import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';

import { MessageService } from '../message.service';
import { ProfileService } from '../profile.service';
import { RepoService } from '../repo.service';
import { TaskService } from '../task.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {
  private messageService = inject(MessageService);
  profileService = inject(ProfileService);
  private repoService = inject(RepoService);
  private taskService = inject(TaskService);
  private cdr = inject(ChangeDetectorRef);
  taskCount = 0;
  processCount = 0;

  ngOnInit(): void {
    this.messageService.set(`Welcome!`);

    // Wait for profile to be loaded before fetching data
    if (this.profileService.isAuthenticated()) {
      this.loadData();
    } else {
      // Listen for profile loaded event
      window.addEventListener('profile:loaded', () => {
        this.loadData();
      }, { once: true });
    }
  }

  private loadData(): void {
    this.taskService.getTaskCount().subscribe(
      count => {
        this.taskCount = count;
        this.cdr.detectChanges();
      }
    );
    this.repoService.getProcessDefinitionCount().subscribe(
      count => {
        this.processCount = count;
        this.cdr.detectChanges();
      }
    );
  }

}
